import findExistingSlot from "./findExistingSlot";

const refetchGoogleAds = config => {
  if (!("googletag" in window && "cmd" in window.googletag && config))
    return false;
  const { adId } = config;

  window.googletag.cmd.push(() => {
    const slots = window.googletag.pubads().getSlots();

    const existingSlot = findExistingSlot(slots, adId);

    if (existingSlot) {
      window.googletag.pubads().refresh([existingSlot]);
    }
  });
};

export default refetchGoogleAds;
